const NO_DIMENSION_ALIAS = 'NONE';
const TOTAL_ALIAS_PREFIX = 'total_';
export const TOTAL_KEY_FIELD = '__TOTAL__';
export const GRAND_TOTAL_KEY_FIELD = '__GRANDTOTAL__';
export const SUBTOTAL_KEY_FIELD = '__SUBTOTAL__';
export const getTotalMeasureAlias = (measure, fixedDimensions) => `${TOTAL_ALIAS_PREFIX}${[...fixedDimensions, measure].join('-')}`;
export const getTotalMeasureAliasPivot = (measure, row = NO_DIMENSION_ALIAS, column = NO_DIMENSION_ALIAS) => getTotalMeasureAlias(measure, [row, column]);
export const isTotalAlias = alias => alias.startsWith(TOTAL_ALIAS_PREFIX);